import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/LanguageContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useI18n();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("session_token", r.data.session_token);
        setUser(r.data.user);
        // Clean hash
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard/profile", { replace: true, state: { user: r.data.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="container-pad py-32 text-center text-slate-500" data-testid="auth-callback-loading">
      {t.auth.processing}
    </div>
  );
}
